<template>
  <div>
    <f7-block-title>
      <span v-if="has_training_sessions">
        Jouw Training Sessies:
      </span>
      <span v-else>
        Klaar om te sporten?
      </span>
    </f7-block-title>
    <f7-card class="card-raised" v-if="!has_training_sessions" style="border-radius: 10px;">
      <f7-card-header
        class="no-border"
        valign="bottom"
        style="width:100%; padding:0;border-radius:10px;"
      >
        <img src="/static/gifs/ready-for-workout.gif" style="width:100%; padding:0;border-radius:10px;" alt="">
      </f7-card-header>
<!--      <f7-card-content :padding="false">-->
<!--        <img src="https://cdn.framework7.io/placeholder/nature-1000x700-8.jpg" width="100%"/>-->
<!--      </f7-card-content>-->
    </f7-card>

    <f7-list media-list class="list-strong list-outline list-dividers" v-if="training_sessions.length">
        <training-session-list-item v-for="training_session in training_sessions" :key="training_session.id"
          :training_session="training_session"
        ></training-session-list-item>
    </f7-list>
    <f7-block v-else>
      <f7-row>
        <f7-col>
          <f7-button outline large @click="$emit('newTraining')">Eerste Training Toevoegen</f7-button>
        </f7-col>
      </f7-row>
    </f7-block>
  </div>
</template>

<script>

    import Moment from 'moment';
    // import 'moment/locale/nl';
    // import 'moment/locale/es';
    import {extendMoment} from 'moment-range';
    import TrainingSessionListItem from "./TrainingSessionListItem.vue";

    const moment = extendMoment(Moment);
    // moment.locale('es');

    export default {
        components: {
            TrainingSessionListItem,
        },

        props: [],

        mixins: [],

        data: function () {
            return {
                last_30_days: [],
            };
        },

        computed: {
            current_user() {
                return this.$store.state.current_user.data;
            },
            training_sessions() {
                return this.$store.getters['training_sessions/training_sessions_reversed'](this.current_user.id);
            },
            has_training_sessions() {
                return this.training_sessions.length > 0;
            }
        },

        created() {
            // this.setLast30Days();
        },

        mounted() {
            //
        },

        methods: {
            setLast30Days() {
                const start = moment().subtract(28, 'days');
                const end = moment();
                let range = moment.range(start, end);
                let moment_array = Array.from(range.by('day')).reverse();
                moment_array.forEach(day => {
                    let dateString = day.format('dddd') + ' ' + day.format('YYYY-MM-DD');
                    this.last_30_days.push(dateString);
                });
            }
        },

        watch: {
            //
        }
    };
</script>
